import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { ButtonToolbar } from 'reactstrap';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import Content from '../../../layout/Content';
import Table from '../../../common/Table';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';

import {
  ITINERARY_FOOD_INVOICE_PATH,
  NEW_ITINERARY_FOOD_INVOICE_PATH,
} from '../../../../config/paths';

import { ITINERARY_FOOD_INVOICES_COLUMNS } from '../../../../config/columns';

import {
  clearItineraryFoodInvoices,
  getItineraryFoodInvoices,
  getItineraryFoodInvoiceSummaryExcel,
} from '../../../../actions/food/ItineraryFoodInvoice';
import ItineraryFoodInvoiceSummaryForm from './ItineraryFoodInvoiceSummaryForm';

export const ItineraryFoodInvoices = ({
  breadcrumbs,
  itineraryFoodInvoices,
  loading,
  dispatchGetItineraryFoodInvoices,
  dispatchClearItineraryFoodInvoices,
  dispatchGetItineraryFoodInvoiceSummaryExcel,
}) => {
  useLayoutEffect(() => () => dispatchClearItineraryFoodInvoices(), []);

  const data = itineraryFoodInvoices.get('content') || [];
  const pages = itineraryFoodInvoices.get('totalPages') || null;
  const defaultPageSize =
    itineraryFoodInvoices.get('size') || DEFAULT_PAGE_SIZE;

  const onSubmitSummaryExcel = ({ summaryNumber }) => {
    dispatchGetItineraryFoodInvoiceSummaryExcel({
      summaryNumber,
    });
  };

  const toolbar = (
    <ButtonToolbar className="pull-right">
      <a href={NEW_ITINERARY_FOOD_INVOICE_PATH} className="btn btn-primary">
        <i className="fa fa-plus" /> Nuevo
      </a>
    </ButtonToolbar>
  );

  const content = (
    <>
      <h3>Descargar Resumen de Factura</h3>

      <ItineraryFoodInvoiceSummaryForm
        onSubmit={onSubmitSummaryExcel}
        loading={loading}
      />

      <hr />

      <h3>Lista de Facturas de Alimentación de Itinerarios</h3>

      <Table
        columns={ITINERARY_FOOD_INVOICES_COLUMNS}
        data={data}
        pages={pages}
        defaultPageSize={defaultPageSize}
        filterable
        fetchData={dispatchGetItineraryFoodInvoices}
        modelPath={ITINERARY_FOOD_INVOICE_PATH}
        loading={loading}
        navigateToModelOnRowClick
      />
    </>
  );

  return (
    <Content
      title="Lista de Facturas de Alimentación de Itinerarios"
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      content={content}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetItineraryFoodInvoices: getItineraryFoodInvoices,
  dispatchClearItineraryFoodInvoices: clearItineraryFoodInvoices,
  dispatchGetItineraryFoodInvoiceSummaryExcel:
    getItineraryFoodInvoiceSummaryExcel,
};

const mapStateToProps = ({ FoodUnit }) => ({
  breadcrumbs: [
    ...FoodUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Facturas de Alimentación de Itinerarios',
      href: ITINERARY_FOOD_INVOICE_PATH,
    },
  ],
  itineraryFoodInvoices: FoodUnit.ItineraryFoodInvoice.getIn([
    'all',
    'content',
  ]),
  loading: FoodUnit.ItineraryFoodInvoice.getIn(['all', 'loading']),
});

ItineraryFoodInvoices.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  itineraryFoodInvoices: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetItineraryFoodInvoices: PropTypes.func.isRequired,
  dispatchClearItineraryFoodInvoices: PropTypes.func.isRequired,
  dispatchGetItineraryFoodInvoiceSummaryExcel: PropTypes.func.isRequired,
};

ItineraryFoodInvoices.defaultProps = {
  itineraryFoodInvoices: Immutable.Map(),
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ItineraryFoodInvoices);
